import { BusinessRelationship } from './businessRelationship';
export class BusinessPartner {
    static constructFromPlainObjectList(objList) {
        const businessPartners = [];
        if (objList && Array.isArray(objList)) {
            for (const obj of objList) {
                businessPartners.push(BusinessPartner.constructFromPlainObject(obj));
            }
        }
        return businessPartners;
    }
    constructor() {
        this.businessPartnerId = null;
        this.city = null;
        this.distributionPartnerNumber = null;
        this.outletName = null;
        this.outletNumber = null;
        this.street = null;
        this.zipCode = null;
        this.businessRelationships = [];
    }
    getBusinessPartnerId() {
        return this.businessPartnerId;
    }
    setBusinessPartnerId(value) {
        this.businessPartnerId = value;
    }
    getCity() {
        return this.city;
    }
    setCity(value) {
        this.city = value;
    }
    getDistributionPartnerNumber() {
        return this.distributionPartnerNumber;
    }
    setDistributionPartnerNumber(value) {
        this.distributionPartnerNumber = value;
    }
    getOutletName() {
        return this.outletName;
    }
    setOutletName(value) {
        this.outletName = value;
    }
    getOutletNumber() {
        return this.outletNumber;
    }
    setOutletNumber(value) {
        this.outletNumber = value;
    }
    getStreet() {
        return this.street;
    }
    setStreet(value) {
        this.street = value;
    }
    getZipCode() {
        return this.zipCode;
    }
    setZipCode(value) {
        this.zipCode = value;
    }
    getBusinessRelationships() {
        return this.businessRelationships;
    }
    setBusinessRelationships(value) {
        this.businessRelationships = value;
    }
}
BusinessPartner.constructFromPlainObject = (source) => {
    let target = new BusinessPartner();
    target = Object.assign(target, source);
    if (source.businessRelationships) {
        target.businessRelationships = BusinessRelationship.constructFromPlainObjectList(source.businessRelationships);
    }
    return target;
};
//# sourceMappingURL=businessPartner.js.map